<template>
  <div class="date-select">
    <span class="date-select__title" v-if="title">{{ title }}</span>
    <date-picker
      v-model="selectedDate"
      :disabled-date="disabledDate"
      :formatter="momentFormat"
      :type="mode"
      :range="range"
      lang="ru"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import moment from "moment";

export default {
  name: "DateComponent",
  props: {
    title: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default() {
        return "date";
      },
    },
    emptyPlaceholder: {
      type: String,
      default() {
        return "Все";
      },
    },
    disabledDate: {
      type: Function,
    },
    range: Boolean,
    loading: Boolean,
    value: [Object, Date],
  },
  data() {
    return {
      selectedDate: undefined,
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('DD.MM.YYYY') : '';
        },
        parse: (value) => {
          return value ? moment(value, 'DD.MM.YYYY').toDate() : undefined;
        },
      }
    };
  },
  mounted() {
    this.selectedDate = this.value;
  },
  watch: {
    value() {
      this.selectedDate = this.value;
    },
  },
  components: {
    DatePicker,
  },
};
</script>

<style lang="stylus">
@import "~@/styles/elements/input.styl"
.date-select {
  display flex
  flex-direction: column
  gap: 5px

  .mx-datepicker {
    width: 100%
  }

  .mx-input {
    @extends .date-input__container
    font-size: inherit
  }

  &__title {
    font-size: 0.75em;
    line-height: 13px;
    color: var(--body-color);
    opacity: 0.5;
    white-space: pre-line;
  }
}
</style>
